/**
 * Template: Page - About Us
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import '../sections/page-about-us';
import '../../styles/templates/page.about-us.scss';

document.addEventListener('DOMContentLoaded', () => {
  load('page-about-us');
});
